import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ContentProvider } from "@/context/ContentContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import BookingPage from "@/pages/BookingPage";
import LegalPage from "@/pages/LegalPage";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <ContentProvider>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/book" element={<BookingPage />} />
                <Route path="/privacy" element={<LegalPage type="privacy" />} />
                <Route path="/cookie" element={<LegalPage type="cookie" />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
          </AuthProvider>
        </ContentProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
